import { createSlice } from '@reduxjs/toolkit';

const chartSlice = createSlice({
  name: 'chart',
  initialState: {
    chartImageUrl: null,
  },
  reducers: {
    setChartImage: (state, action) => {
      state.chartImageUrl = action.payload;
    },
    clearChartImage: (state) => {
      state.chartImageUrl = null;
    },
  },
});

export const { setChartImage, clearChartImage } = chartSlice.actions;
export default chartSlice.reducer;